/* eslint-disable import/no-duplicates */
import React, { useState, FunctionComponent, memo, ReactElement } from 'react'

import { Divider, Grid } from '@material-ui/core'
import { format } from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'

import logoTmov from 'shared/assets/images/logoTmovPay.svg'

import {
  TextTime,
  TextType,
  Text,
  Header,
  Logo,
  TextHeader,
  TextHeaderBold,
  ContainerAccountData,
  Center,
  Container,
  TotalValue,
} from './styles'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import ExportarExtratoItem from '../ExportarExtratoItem'
import { useCartao } from 'modules/pagamentos/hooks/useCartao'
import { useFiltro } from 'modules/pagamentos/hooks/useFiltro'
import { cnpjMask } from 'shared/utils/formatters'
import { useAuth } from 'modules/auth/hooks/auth'
import IFindAllExtratoResponse from 'modules/pagamentos/domain/entities/IFindAllExtratoResponse'

interface ExportarIExtratoPdfProps {
  dados: IFindAllExtratoResponse
  dataInicial: Date
  dataFinal: Date
}

const ExportarExtratoPdf: FunctionComponent<ExportarIExtratoPdfProps> = ({
  dados,
  dataInicial,
  dataFinal,
}) => {
  const dataInicialFormatada = new Date(dataInicial)
  const dataFinalFormatada = new Date(dataFinal)
  const { frotista } = useFrotista()
  const { cartao } = useCartao()
  const { extrato } = useFiltro()
  const { usuario_id } = useAuth()
  const usuario = frotista.usuarios?.find(usuario => usuario.id === usuario_id)

  const formatMoney = (value: number) => {
    return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  }

  return (
    <Container>
      <Header>
        <Logo src={logoTmov} />
        <ContainerAccountData>
          <TextHeaderBold>{usuario?.nome}</TextHeaderBold>
          <Center>
            <div>
              <TextHeaderBold>CNPJ</TextHeaderBold>
              <TextHeader>{cnpjMask(frotista?.cnpj || '')}</TextHeader>
            </div>
            {cartao.conta && (
              <>
                <TextHeader>/</TextHeader>
                <TextHeaderBold>Conta</TextHeaderBold>
                <TextHeader> {cartao.conta} </TextHeader>
              </>
            )}
          </Center>
        </ContainerAccountData>
      </Header>
      <Grid container justifyContent="space-around" style={{ padding: '24px' }}>
        <TextTime>
          {format(dataInicialFormatada, "dd 'de' MMMM 'de' yyyy", {
            locale: ptBR,
          })}{' '}
          a{' '}
          {format(dataFinalFormatada, "dd 'de' MMMM 'de' yyyy", {
            locale: ptBR,
          })}
        </TextTime>
        <Grid
          style={{
            border: '1px solid #B2BBBF',
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
            padding: '16px 0',
          }}
          container
          justifyContent="center"
        >
          <Grid item md={5}>
            <TextType>Saldo final</TextType>
            <TotalValue isValorFinal={true}>
              {formatMoney(dados.saldo_final_periodo ?? 0)}
            </TotalValue>
          </Grid>
        </Grid>
      </Grid>

      <Grid container alignItems="center" style={{ padding: '0 24px' }}>
        <Grid item xs={1}>
          <Text>Movimentações</Text>
        </Grid>
        <Grid item xs={11}>
          <Divider />
        </Grid>
      </Grid>
      <Grid container style={{ padding: '0 24px' }}>
        {extrato?.detalhes &&
          !!extrato?.detalhes.length &&
          extrato?.detalhes.map(item => {
            return (
              <ExportarExtratoItem
                key={`${item.protocolo_requisicao} ${item.data}`}
                item={item}
              />
            )
          })}
      </Grid>
    </Container>
  )
}
export default memo(ExportarExtratoPdf)
